module.exports = __webpack_public_path__ + "static/media/affordable-catering-1.a3e31aab.jpg";